import axiosInstance from "services/service-instance";


export default {
    getDashboardColumns: () =>
        axiosInstance.get("/case/list/decisioning-headers/"),
    getDashboardRows: (page, pageSize, filters, stageId) =>
        axiosInstance.get("/case/list/decisioning/", {
            params: {
                page,
                page_limit: pageSize,
                ...filters,
                stage_id: stageId
            }
        }),
    bulkProceed: (case_task_ids, this_stage, this_user, remarks) =>
        axiosInstance.post("/case/proceed/bulk/", {
            case_task_ids, this_stage, this_user, remarks
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    bulkRefer: (case_task_ids, this_stage, this_user, remark) =>
        axiosInstance.post("/case/refer/bulk/", {
            case_task_ids, 
            this_stage, 
            this_user, 
            reassignment_reason: remark,
            remarks: remark
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    bulkSanction:  (caseIds, sanctionConditionObj) =>
        axiosInstance.post(`/case/bulk-sanction/?case_ids=${caseIds}`, {
            ...sanctionConditionObj
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getSanctionConditions: (caseId) => 
        axiosInstance.get(`/case/${caseId}/sanction-condition/?Content-Type=application/json`),
    bulkExport: (filters) =>
        axiosInstance.get("/case/list/decisioning/export/", {
            params: {
                ...filters
            },
            responseType: "arraybuffer"
        })
};